import { connect } from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';

import { logout as logoutAction, fetchUser as fetchUserAction } from 'app/common/actions/user';
import { fetchApps as fetchAppsAction } from 'app/actions/apps/apps';
import { dealerFetch as fetchDealerAction } from 'app/actions/dealer';
import { fetchStudents as fetchStudentsAction } from 'app/actions/students';
import { fetchSettings as fetchSettingsAction } from 'app/common/actions/settings/load';
import { fetchDocuments as fetchDocumentsAction } from 'app/common/actions/documents';
import { fetchBalance as fetchBalanceAction } from 'app/common/actions/user/balance';

import {
  saveRouterParams as saveRouterParamsAction,
  needRefresh,
} from 'app/common/actions/settings/current';

import * as websockets from 'app/actions/websockets';
import { fetchUnreadEvents as fetchUnreadEventsAction } from 'app/actions/events/unread';
import { serviceWorkerUpdate } from 'app/common/components-next/service-worker';


export default compose(
  connect(
    state => ({
      title: `Личный кабинет - ${state.dealer.project_name}`,
      user: state.user,
      // disconnected: state.settings.current.disconnected,
      isNeedRefresh: state.settings.current.needRefresh,
      students: state.students.keys,
      schools: state.schools.keys,
      loading:
        state.user.result !== 'success' || state.user.loading
        || state.students.didInvalidate || state.students.loading
        || state.apps.opts.didInvalidate || state.apps.opts.loading,
    }),
    dispatch => ({
      logout: () => dispatch(logoutAction()),
      fetchUser: silent => dispatch(fetchUserAction(silent)),
      fetchApps: silent => dispatch(fetchAppsAction(silent)),
      fetchDealer: () => dispatch(fetchDealerAction()),
      fetchStudents: silent => dispatch(fetchStudentsAction(silent)),
      fetchSettings: () => dispatch(fetchSettingsAction()),
      saveRouterParams: params => dispatch(saveRouterParamsAction(params)),
      // connect: () => dispatch(connectAction()),
      webSocketsStart: () => websockets.start(dispatch),
      webSocketsStop: websockets.stop,
      fetchUnreadEvents: () => dispatch(fetchUnreadEventsAction()),
      // fetchOffers: silent => dispatch(fetchOffersAction(silent)),
      fetchDocuments: silent => dispatch(fetchDocumentsAction(false, silent)),
      fetchBalance: () => dispatch(fetchBalanceAction()),
      dispatch,
    }),
  ),

  // withState('mounted', 'setMounted', true),

  withHandlers({
    refresh: ({ dispatch }) => () => {
      // setMounted(false, () => setMounted(true));
      dispatch(needRefresh(true));
    },
  }),

  withHandlers({
    fetchData: props => () => {
      // props.connect();
      props.fetchUser();
      props.fetchSettings();
      props.fetchStudents();
      props.fetchApps();
      props.fetchDealer();
      props.fetchBalance();
      // props.fetchOffers();
      // props.refresh();
    },
  }),

  lifecycle({

    componentDidMount() {
      // Убираем фон логина
      this.saved = document.getElementsByTagName('body')[0].getAttribute('style');
      document.getElementsByTagName('body')[0].removeAttribute('style');

      const { params } = this.props;
      if (params.id || params.schoolId) {
        const id = parseInt(params.id, 10);
        const schoolId = parseInt(params.schoolId, 10);
        const save = {};
        if (id) {
          save.id = id;
        }
        if (schoolId) {
          save.schoolId = schoolId;
        }
        this.props.saveRouterParams(save);
      }
      this.props.fetchSettings();
      this.props.fetchStudents();
      this.props.fetchUser();
      this.props.fetchDealer();
      this.props.fetchApps();
      // websockets отключены (не подключаемся к wss://new-lk0.sms-dnevnik.com/ws)
      // this.props.webSocketsStart();
      this.props.fetchUnreadEvents();
      // this.props.fetchOffers();
      this.props.fetchDocuments();
      this.props.fetchBalance();
    },

    componentDidUpdate(prevProps) {
      const {
        params,
        user,
        isNeedRefresh,
        dispatch,
        location,
        fetchData,
        fetchDocuments,
        fetchStudents,
        fetchApps,
        fetchUser,
        fetchBalance,
        saveRouterParams,
        students,
        schools,
      } = this.props;

      const prevParams = prevProps.params;

      if (isNeedRefresh && !prevProps.isNeedRefresh) {
        dispatch(needRefresh(false));
        fetchData();
      }
      if (params.id && prevParams.id !== params.id) {
        const id = parseInt(params.id, 10);
        if (id && students && students.includes(id)) {
          saveRouterParams({ id });
        }
      }
      if (params.schoolId && prevParams.schoolId !== params.schoolId) {
        const schoolId = parseInt(params.schoolId, 10);
        if (schoolId && schools && schools.includes(schoolId)) {
          saveRouterParams({ schoolId });
        }
      }
      // если вошел студент
      if (user && user.student && user.student.id) {
        saveRouterParams({ id: user.student.id });
      }
      // переодическое обновление данных при активности пользователя
      if (location.pathname !== prevProps.location.pathname) {
        // this.props.fetchOffers();
        fetchDocuments();
        fetchStudents(true);
        fetchApps(true);
        fetchUser(true);
        fetchBalance();
        // service-worker
        serviceWorkerUpdate();
      }
    },

    componentWillUnmount() {
      this.props.webSocketsStop();
      document.getElementsByTagName('body')[0].setAttribute('style', this.saved);
    },

  }),
);
